"use client";

import type { ButtonHTMLAttributes, MouseEvent } from "react";
import { useRouter } from "next/navigation";

import { cn } from "@/lib/utils";

type ContextualBackButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  fallbackHref: string;
};

export function ContextualBackButton({
  fallbackHref,
  className,
  onClick,
  type = "button",
  ...props
}: ContextualBackButtonProps) {
  const router = useRouter();

  function handleClick(event: MouseEvent<HTMLButtonElement>) {
    onClick?.(event);
    if (event.defaultPrevented) return;

    if (window.history.length > 1) {
      router.back();
      return;
    }

    router.replace(fallbackHref);
  }

  return (
    <button
      {...props}
      type={type}
      onClick={handleClick}
      className={cn(className, "cursor-pointer")}
    />
  );
}
